import type { VoidFunctionComponent } from 'react';

import { type IssueType, type LicensingIssueType } from '../../../../../../../shared/issuesV2';
import { BadgeColors, BadgeSizes, TooltipBadge } from '../../../../../generic';
import Icon, { type IconClassName, icons } from '../../../../../generic/Icon';

import styles from './DependencyLicenses.module.less';

type Props = {
  issueType?: IssueType
  isIgnored?: boolean;
};

export const PolicyStatusBadge: VoidFunctionComponent<Props> = ({ issueType, isIgnored }) => {
  const issueTypeMap: Record<LicensingIssueType, string> = {
    policy_flag: 'Flagged',
    policy_conflict: 'Denied',
    unlicensed_dependency: 'Unlicensed',
    unconcluded_dependency: 'Unconcluded',
  };

  // Default to a checkmark on a green badge to represent an approved license.
  let icon: IconClassName = icons.badgeCheck;
  let badgeColor: BadgeColors = BadgeColors.DarkGreen;

  switch (issueType) {
    case 'policy_flag':
      icon = icons.flagOutline;
      badgeColor = isIgnored ? BadgeColors.LightYellow : BadgeColors.Yellow;
      break;
    case 'policy_conflict':
      icon = icons.banOutline;
      badgeColor = isIgnored ? BadgeColors.LightRed : BadgeColors.DarkRed;
      break;
    default:
      break;
  }

  return (
    <TooltipBadge
      color={badgeColor}
      size={BadgeSizes.Micro}
      id={`policy-status-badge-${issueType}`}
      tooltip="Issue is ignored."
      showTooltip={isIgnored}
    >
      <div className={styles.policyStatusText}>
        <Icon icon={isIgnored ? icons.eyeSlash : icon} />
        {(issueType && issueTypeMap[issueType as LicensingIssueType]) || 'Approved'}
      </div>
    </TooltipBadge>
  );
};
